
angular.module('classy.models', ['classy.core'])

.classy.plugin.controller({

    localInject: ['ModelService', '$scope'],

    postInit: function(cls, deps, module) {
        var unsubs = [],
            listen = cls.listen || {},
            modelName, action, fn;

        for (modelName in listen) {
            for (action in listen[modelName]) {
                fn = listen[modelName][action];
                if (angular.isString(fn)) {
                    fn = cls[fn];
                }
                fn = angular.bind(cls, fn);
                unsubs.push(this.ModelService.listenFor(action, modelName, fn));
            }
        }

        this.$scope.$on('$destroy', function() {
            for (var i = 0; i < unsubs.length; i++) {
                unsubs[i]();
            }
        });
    },
});
